<template>
  <video
    :data-src="videoData.src"
    :muted="muted"
    :loop="loop"
    :autoplay="autoplay"
    playsinline
    :data-poster="videoData.posterimage"
  >
    <source src="data:video/mp4;base64,AAAA" :type="videoData.type" />
  </video>
</template>
<script>
export default {
    name: "video-block",
    props:{ 
        autoplay :{
            default:true,
            type: Boolean
        },
        loop :{
            default:true,
            type: Boolean
        },
        muted :{
            default:true,
            type: Boolean
        },
        videoData:{
            type: Object
        }
    },
    mounted() {
        let seodata = this.videoData.seodata;
        if(seodata != null) {
            let f =  '\n' + '{' + '\n' +
            ' "@context": "https://schema.org", ' + '\n' +
            ' "@type": "VideoObject",' + '\n' +
            ' "name": ' + seodata.description + ',\n' +
            ' "description": ' + seodata.description + ',\n' +
            ' "thumbnailUrl": ' + seodata.thumbnailUrl + ',\n' +
            ' "uploadDate": ' + seodata.uploadDate + ',\n' +
            ' "contentUrl": ' + seodata.contentUrl + ',\n' ;
            if(seodata.duration != '') {
                f = f + '"duration":' + seodata.duration + ',\n' ;
            }
            if(seodata.userInteractionCount != '') {
                f = f + '"interactionStatistic": { ' + '\n' + '"@type" : "InteractionCounter",' + '\n' + 
                    '"interactionType": {' + '\n' + ' "@type": "WatchAction"'  + '\n' +  '},' + '\n' + '"userInteractionCount":' + seodata.userInteractionCount + ',' + '\n' 
            + '},\n';
            }
            if(seodata.regionsAllowed != '') {
                 f = f + '"regionsAllowed":' + seodata.regionsAllowed + ',\n';
            }
            f = f  + "}"; 
            console.log(f,"-f-");
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = f;
            document.head.append(script);
        }
    }
}
</script>
